<template>
  <RequiresPermission
    permission="view_platform_overview"
    fallback-route-name="merchantIndex"
  >
    <div class="flex w-full flex-col space-y-4">
      <BaseCard class="relative">
        <PlatformSummary source="tpplus" />
      </BaseCard>
      <BaseCard class="relative">
        <LastTransactions source="tpplus" />
      </BaseCard>

      <BaseCard class="relative">
        <WeeklyTransactionSummary source="tpplus" />
      </BaseCard>
    </div>
  </RequiresPermission>
</template>

<script setup lang="ts">
const { currentUser } = useCurrentUser()
const router = useRouter()

// Needed so that navigating to control.takepaymentsplus.com does not result in a permissions
whenever(
  () =>
    currentUser.value &&
    !currentUser.value.permissions.includes(
      "view_platform_overview"
    ),
  () => {
    router.push({ name: "merchantIndex" })
  },
  { immediate: true }
)
</script>
